import _ from "lodash";
import QueryHospitalityEvents from 'graphql/queries/QueryHospitalityEvents'
import { decode } from 'html-entities'
import store from 'services/redux/store'
import { setDataByGuid } from 'services/redux/data/actions'
import { dataConstants } from 'services/redux/data/constants'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import HelperDate, { dateFormat } from 'utils/helper-date'

export default class FetchHospitalityEvents {
	
	static fetch({ callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'hospitality_manager_events', QueryHospitalityEvents, {
			instant: true,
			resultPath: [ 'hospitality_manager_events' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					
					const events = this.process( result )
					
					store.dispatch( setDataByGuid( dataConstants.EVENTS, events ) );
					
					callbackSuccess( {
						events: _.orderBy( events, ['sort_date', 'sort_time'], ['asc', 'asc'] ),
					} );
				}
			}
		})
	}
	
	static process( events ) {
		const result = [];
		_.forEach( events, event => {
			const dates = event.date.split(' - ')
			const times = event.time.split(' - ')
			
			// Add the sort
			event.sort_date = dates[ 0 ]
			event.sort_time = times[ 0 ]
			
			_.forEach( event, ( value, key) => {
				event[ key ] = decode( value );
			})
			
			// Time and date
			event.time = _.join( _.map( times, time => {
				return HelperDate.date(time, dateFormat.FULL_TIME).format(dateFormat.SHORT_TIME);
			} ), ' - ' );
			event.date = _.join( _.map( dates, date => {
				return HelperDate.date(date, dateFormat.DATE).format(dateFormat.DATE_PRETTY);
			} ), ' - ' );
			
			event.datetime = `${event.date}: ${event.time}`
			
			result.push( event )
		})
		
		return result
	}
}
